export default __webpack_public_path__ + "static/media/discipline-journalism.ff696689.svg";